import { type FC, useMemo } from 'react';

import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Divider,
  Heading,
  Tab,
  TabIndicator,
  TabList,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { ADMIN_PATH } from '@/features/admin';

export const AdminSettingsSettingsLayout: FC = () => {
  const { t } = useTranslation(['components', 'auth']);
  const navigate = useNavigate();
  const location = useLocation();

  const TABS = [
    {
      id: 'communication',
      label: t('components:settings.account.settings.communicationSettings'),
      linkTo: `${ADMIN_PATH}/settings/communication`,
    },
    {
      id: 'sharing',
      label: t('components:settings.account.settings.sharingHistory'),
      linkTo: `${ADMIN_PATH}/settings/sharing`,
    },
    {
      id: 'integrations',
      label: t('components:settings.account.settings.integrations'),
      linkTo: `${ADMIN_PATH}/settings/integrations`,
    },
    {
      id: 'plans',
      label: t('components:settings.account.settings.billingPlans'),
      linkTo: `${ADMIN_PATH}/settings/plans`,
    },
    // {
    //   id: 'notifications',
    //   label: t('components:settings.account.settings.notifications'),
    //   linkTo: `${ADMIN_PATH}/settings/notifications`,
    // },
  ] as const;

  const activeIndex = useMemo(
    () => TABS.findIndex((tab) => location.pathname.startsWith(tab.linkTo)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [location.pathname]
  );

  return (
    <Card borderRadius="xl">
      <CardHeader>
        <Heading fontSize="2xl" fontWeight="semibold">
          {t('auth:admin.layout.accountMenu.emailSettings')}
        </Heading>
      </CardHeader>
      <Divider borderWidth="1px" />
      <CardBody>
        <Tabs
          position="relative"
          variant="unstyled"
          index={activeIndex}
          onChange={(index) => navigate(TABS[index]!.linkTo)}
        >
          <TabList>
            {TABS.map((tab) => (
              <Tab
                key={tab.id}
                fontWeight="semibold"
                _selected={{
                  color: 'brand.500',
                  borderBottomColor: 'brand.500',
                }}
              >
                {tab.label}
              </Tab>
            ))}
          </TabList>
          <Divider borderColor="gray.50" borderWidth="1px" />

          <TabIndicator
            mt="-1.5px"
            height="2px"
            bg="brand.500"
            borderRadius="1px"
          />

          <TabPanels>
            <Box px={0} pt={6} pb={0}>
              <Outlet />
            </Box>
          </TabPanels>
        </Tabs>
      </CardBody>
    </Card>
  );
};
